<template>
    <div class="form-input__wrap">
        <InputLabel>
                {{prettyName}}
                <span class="form-input__requirement" v-if="$slots.requirement">
                    <slot name="requirement"></slot>
                </span>
                <ValidationProvider :name="prettyName" :rules="validationRules" v-slot="{ errors }" persist>
                    <input :placeholder="placeholder ? placeholder : prettyName"
                            :min="min"
                            :max="max"
                            :name="name"
                            :type="type"
                            v-model="internalValue"
                            :disabled="disabled"
                            ref="input"
                            class="form-input__input">
                    <span class="form-input__errors" v-if="errors[0]">
                        {{ errors[0] }}<br>
                    </span>
                    <span class="form-input__errors form-input__errors--server" v-for="(e, index) in responseErrors" :key="index">{{e}}<br></span>
                </ValidationProvider>
        </InputLabel>
    </div>
</template>

<script>
    import InputLabel from './InputLabel'
    export default {
        name: 'FormTextInput',

        data () {
            return {
                errors: [],
                internalValue: this.initialValue || ''
            }
        },

        components: {
            InputLabel,
        },

        props: {
            initialValue: [String, Object, Array],
            value: String,
            validationRules: String,
            prettyName: String,
            name: String,
            placeholder: String,
            min: Number,
            max: Number,
            disabled: [String, Boolean],
            responseErrors: Array,
            type: {
                type: String,
                default: 'text'
            }
        },
        watch: {
            value (newValue) {
                this.internalValue = newValue;
            },
            internalValue (newValue) {
                this.$emit('input', newValue);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-input {
        &__input {
            font-family: inherit;
            outline: none;
            margin-top: 5px;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            background: #FFFFFF;
            border: 1px solid #DDDDDD;
            box-sizing: border-box;
            border-radius: 2px;
            padding: 10px;
            width: 100%;
            display: block;
            transition: border 0.2s ease-in-out;

            &:disabled {
                background: #F3F3F3;
            }

            &:focus {
                border: 1px solid #33AADD;
            }
        }
    }
</style>

<style lang="scss">
    .form-input {
        &__wrap {
            display: block;
            margin-bottom: 20px;
        }
        &__requirement {
            float: right;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 19px;
            text-align: right;
            color: #999999;
        }
        &__errors {
            font-size: 12px;
            font-weight: normal;
            line-height: 16px;

            &--server {
                color: #F43;
            }
        }
    }

    input::placeholder {
        color: #999;
        opacity: 0.5;
    }

    .form-input__errors-transition {

    }
</style>